<template>

    <b-card :border-variant="!errors.items.length ? 'success' : 'danger'"
            :header="$t('titles.register')"
            header-tag="header"
            :header-bg-variant="!errors.items.length ? 'success' : 'danger'"
            header-text-variant="white">
        <blocking-container v-if="$wait.is('register')"></blocking-container>
        <b-form @submit.prevent="validate" data-vv-scope="register">

            <b-form-group :label="`${$t('fields.first_name')}:`">
                <b-form-input v-validate="'required|max:255'"
                              data-vv-value-path="localValue"
                              data-vv-name="first_name"
                              :data-vv-as="$t('fields.first_name')"
                              id="first_name"
                              type="text"
                              v-model="user.first_name"
                              :state="errors.has('register.first_name') ? false : null"
                              aria-describedby="input-feedback-first_name"
                              :placeholder="$t('placeholders.first_name')">
                </b-form-input>

                <b-form-invalid-feedback id="input-feedback-first_name">
                    <template v-show="errors.has('register.first_name')">{{ errors.first('register.first_name') }}</template>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="`${$t('fields.last_name')}:`">
                <b-form-input v-validate="'required|max:255'"
                              data-vv-value-path="localValue"
                              data-vv-name="last_name"
                              :data-vv-as="$t('fields.last_name')"
                              id="last_name"
                              type="text"
                              v-model="user.last_name"
                              :state="errors.has('register.last_name') ? false : null"
                              aria-describedby="input-feedback-last_name"
                              :placeholder="$t('placeholders.last_name')">
                </b-form-input>

                <b-form-invalid-feedback id="input-feedback-last_name">
                    <template v-show="errors.has('register.last_name')">{{ errors.first('register.last_name') }}</template>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="`${$t('fields.email')}:`">
                <b-form-input v-validate="'required|email|max:255'"
                              data-vv-value-path="localValue"
                              data-vv-name="email"
                              :data-vv-as="$t('fields.email')"
                              id="email-register"
                              type="text"
                              v-model="user.email"
                              :state="errors.has('register.email') ? false : null"
                              aria-describedby="input-feedback-email-register"
                              :placeholder="$t('placeholders.email')">
                </b-form-input>

                <b-form-invalid-feedback id="input-feedback-email-register">
                    <template v-show="errors.has('register.email')">{{ errors.first('register.email') }}</template>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group>
                <template v-slot:label class="col-form-legend col-12">
                    {{ $t('fields.firm_name') }}:
                    <span class="near-label-info text-secondary">
                        <font-awesome-icon id="companyPopover" :icon="['fas', 'info-circle']" />
                        <b-popover target="companyPopover" triggers="click" placement="rightbottom" >
                            <i18n path="messages.company_info.message" tag="p" for="messages.company_info.email">
                                  <a :href="`mailto:${$t('messages.company_info.email')}`">{{ $t('messages.company_info.email') }}</a>
                            </i18n>
                        </b-popover>
                    </span>
                </template>

                <companies-multiselect v-validate="''"
                                       data-vv-name="company_id"
                                       :data-vv-as="$t('fields.firm_name')"
                                       v-model="user.company_id"
                                       :initial-value="user.company"
                                       :state="errors.has('register.company_id')"
                                       :placeholder="$t('placeholders.firm_name')">
                </companies-multiselect>

                <div class="invalid-feedback d-block m-0" v-show="errors.has('register.company_id')">
                    {{ errors.first('register.company_id') }}
                </div>
            </b-form-group>

            <b-form-group :label="`${$t('fields.password')}:`">
                <input name="password"
                              ref="password"
                              v-validate="'required|min:6|max:255'"
                              class="form-control"
                              data-vv-name="password"
                              :data-vv-as="$t('fields.password')"
                              type="password"
                              v-model="user.password"
                              :class="errors.has('register.password') ? 'is-invalid' : null"
                              aria-describedby="input-feedback-password-register"
                              :placeholder="$t('placeholders.password')" />

                <b-form-invalid-feedback id="input-feedback-password-register">
                    <template v-show="errors.has('register.password')">{{ errors.first('register.password') }}</template>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="`${$t('fields.repeat_password')}:`">
                <input v-validate="'required|confirmed:password'"
                              :data-vv-as="$t('fields.password_confirmation')"
                              type="password"
                              name="password_confirmation"
                              v-model="user.password_confirmation"
                              class="form-control"
                              :class="errors.has('register.password_confirmation') ? 'is-invalid' : null"
                              aria-describedby="input-feedback-password_confirmation"
                              :placeholder="$t('placeholders.password_confirmation')" />

                <b-form-invalid-feedback id="input-feedback-password_confirmation">
                    <template v-show="errors.has('register.password_confirmation')">{{ errors.first('register.password_confirmation') }}</template>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group>
                <b-form-checkbox v-validate="'required|is:1'"
                                 data-vv-value-path="localValue"
                                 data-vv-name="terms"
                                 name="terms"
                                 v-model="status"
                                 value="1"
                                 unchecked-value="0"
                                 :state="errors.has('register.terms') ? false : null"
                                 aria-describedby="input-feedback-terms">
                    <i18n path="term" tag="span" for="tos">
                        <a href="https://www.mittagsgutessen.de/j/privacy" target="_blank">{{ $t('tos') }}</a>
                    </i18n>
                </b-form-checkbox>
                <div>
                    <small class="text-danger" v-show="errors.has('register.terms')">{{ $t('errors.terms')}}</small>
                </div>
            </b-form-group>

          <b-form-group>
            <b-form-checkbox v-validate="'required'"
                             data-vv-value-path="localValue"
                             data-vv-name="post_subscription"
                             name="post_subscription"
                             v-model="user.post_subscription"
                             value="1"
                             unchecked-value="0"
                             :state="errors.has('register.post_subscription') ? false : null"
                             aria-describedby="input-feedback-post_subscription">
                {{ $t('post_subscription') }}
            </b-form-checkbox>
            <div>
              <small>{{ $t('post_subscription_description') }}</small>
            </div>
          </b-form-group>

          <b-form-group>
            <b-form-checkbox v-validate="'required'"
                             data-vv-value-path="localValue"
                             data-vv-name="is_email_reminder_enabled"
                             name="is_email_reminder_enabled"
                             v-model="user.is_email_reminder_enabled"
                             value="1"
                             unchecked-value="0"
                             :state="errors.has('register.is_email_reminder_enabled') ? false : null"
                             aria-describedby="input-feedback-is_email_reminder_enabled">
              {{ $t('email_subscription') }}
            </b-form-checkbox>
            <div>
              <small>{{ $t('email_subscription_description') }}</small>
            </div>
          </b-form-group>

            <b-button class="float-right" :disabled="errors.has('register.*')" type="submit"
                      :variant="'outline-' + (!errors.has('register.*') ? 'success' : 'danger')">Speichern
            </b-button>
        </b-form>
    </b-card>

</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VLayout from '@/layouts/Default';
import CompaniesMultiselect from '@/components/CompaniesMultiselect';
import BlockingContainer from '@/components/BlockingContainer';

export default {

  name: 'RegisterForm',

  components: {
    VLayout,
    BlockingContainer,
    CompaniesMultiselect,
    FontAwesomeIcon,
  },

  // mixins: [postSubscriptionDialog],

  data() {
    return {
      user: {
        first_name: null,
        last_name: null,
        email: null,
        company_id: null,
        password: null,
        password_confirmation: null,
        company: null,
        post_subscription: 1,
        register_ps: 1,
        is_email_reminder_enabled: 1,
      },
      status: 0,
    };
  },

  methods: {
    validate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$wait.start('register');
          // this.postSubscribe('user', 'register');
          this.register();
        }
      });
    },
    register() {
      this.$store.dispatch('auth/register', {
        redirect: 'my-account.index',
        user: this.user,
        successCallback: () => {
          this.$emit('login', this.user);
          this.$wait.end('register');
        },
        callback: () => this.$wait.end('register'),
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Register/Form.vue